import { Component, EventEmitter, forwardRef, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../../form-input-components/base-control-value-accessor';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-multiselect',
  templateUrl: './multiselect.component.html',
  styleUrls: ['./multiselect.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiselectComponent),
      multi: true
    }
  ]
})
export class MultiselectComponent extends BaseControlValueAccessor<Array<any>> implements OnInit, OnDestroy, OnChanges {

  constructor() { super(); }
  @Input() formControl;
  @Input() options;
  @Input() labelKey: string;
  @Input() valueKey: string;
  @Input() optionMap;
  @Input() label: string;
  @Input() width: string;
  @Input() dropdownListWidth: string;
  @Input() height: string;
  @Input() dropdownListHeight: string;
  @Input() showSelectedFilter: boolean = false;
  @Input() isEmitAllowed: boolean = false;

  @Output() handleApplyFilters = new EventEmitter();

  selectedItems = [];
  data: any = [];
  selectedValue = new FormControl();
  dropdownData = [];
  checkValue(e) {
    this.selectedItems = e;
    let data;
    if (this.selectedItems && this.selectedItems.length) {
      data = this.selectedItems.map(item => item.label);
    }
    this.onChange(data);
    // this.label === "vender"" || this.label === "booking tye""
    if (this.isEmitAllowed) {
      if (!(this.formControl.errors && this.formControl.errors.required)) {
        this.handleApplyFilters.emit();
      }
    }
  }

  private destroy$ = new Subject;
  customLabel: string;
  filterValuesCount: number;

  ngOnInit() {
    if (this.options && this.options.length) {
      this.data = this.options.map(option => {
        return {
          label: this.valueKey ? option[this.valueKey] : option,
          value: this.labelKey ? option[this.labelKey] : option
        };
      });
    }
    if (this.formControl.value) {
      if (this.formControl.value.toLowerCase() === 'all') {
        this.selectedValue.setValue(this.options);
        this.selectedItems = this.data;
      } else {
        const value = this.formControl.value.split(',').map(item => item.trim());
        this.selectedValue.setValue(value);
        const value1 = this.formControl.value.split(',').map(option => {
          return {
            label: this.valueKey ? option[this.valueKey].trim() : option.trim(),
            value: this.labelKey ? option[this.labelKey].trim() : option.trim()
          };
        });
        this.selectedItems = value1;
      }
      // this.formControl.setValue(this.selectedValue.value);
      let data;
      if (this.selectedItems && this.selectedItems.length) {
        data = this.selectedItems.map(item => item.label);
      }
      this.formControl.setValue(data);

      /*   if (this.formControl.value.toLowerCase() === 'all') {
          this.selectedValue.setValue(this.data);
          this.selectedItems = this.data;
        } else {
          const value = this.formControl.value.split(',').map(option => {
            return {
              label: this.valueKey ? option[this.valueKey] : option,
              value: this.labelKey ? option[this.labelKey] : option
            }
          });
          this.selectedItems = value;
          // this.selectedValue.setValue(value);
        }
        this.formControl.setValue(this.selectedValue.value); */
    }

    // Watcher
    if(this.showSelectedFilter){
      this.formControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value)=>{
        this.setFilterDisplay();
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(this.options).map((data: any) => {
      this.dropdownData.push({ label: this.options[data], value: this.options[data] });
    });
  }
  /*  isChecked() {
     return this.selectedValue.value &&
          this.selectedValue.value.length === this.options.length;
   }

   isIndeterminate() {
     if (this.selectedValue.value && this.selectedValue.value.length) {
         return this.selectedValue.value.length !== this.options.length;
     }
     return false;
   }

   toggleSelection(change: MatCheckboxChange): void {
     if (change.checked) {
       this.selectedValue.setValue(this.valueKey ? this.options.map((option) => option[this.valueKey]) : this.options);
     } else {
         this.selectedValue.setValue([]);
     }
     this.onChange(this.selectedValue.value);
   } */

   setFilterDisplay(){
    if(this.formControl){
      const filteredValues = this.formControl.value;
      // const maxDisplayLength = this.width > 150;

      if(filteredValues &&
        filteredValues instanceof Array && 
        filteredValues.length && 
        filteredValues.length !== this.options.length){
        this.customLabel = filteredValues[0];
        this.filterValuesCount = this.formControl.value.length - 1;
      } else {
        this.customLabel = null;
        this.filterValuesCount = null;
      }
    }
  }

  ngOnDestroy() {
    this.selectedValue.setValue([]);
    this.onChange(null);
    this.destroy$.next();
    this.destroy$.complete();
  }
}
